import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=5c2f616a&scoped=true&"
import script from "./IconLogo.vue?vue&type=script&lang=js&"
export * from "./IconLogo.vue?vue&type=script&lang=js&"
import style0 from "./IconLogo.vue?vue&type=style&index=0&id=5c2f616a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f616a",
  null
  
)

export default component.exports